import useSWR from "swr";

import { fetcher, User } from "../lib/api";

type Session = {
  authenticity_token: string;
  redirect_to: string;
  user?: User;
};

export default function useSession() {
  const { data: session } = useSWR<Session>("session", fetcher);

  return session;
}
